<template>
  <div class="footer">
    <div class="footer-wrap w">
      <div class="left">
        <div class="logo">
          <div class="img-wrap">
            <img class="img" :src="$globalHeader.fileUrl+'/static/xmdch/yx/logo_4.png'" alt="logo" />
          </div>
        </div>
      </div>
      <div class="center">
        <!-- <div class="title">联系我们</div> -->
        <div class="content">
          <div>
            <span class="label">厦门市产教融合促进会</span>
            <span>地址：厦门市集美区后溪镇珩圣路386号厦门北站商业广场南广场南268号之十 </span>
          </div>
          <div>
            <span class="label">电话：0592-2191066</span>
            <!-- <span class="label">传真：0592-2565766</span> -->
            <span class="label">邮箱：157235262@qq.com</span>
          </div>
          <div class="icp-wrap">
            <span class="label">ICP备案编号：</span>
            <span class="label" @click="handleICP()">闽ICP备14003965号-1</span>
          </div>
          <div>
            <span class="label">

            </span>
          </div>
          <div>
            <!-- <span class="label">技术支持：爱莫微网络科技有限公司</span> -->

          </div>
        </div>
      </div>
      <div class="right">
        <div class="content">
          <div class="img-wrap">
            <img class="img" :src="$globalHeader.fileUrl+'/static/xmdch/yx/qrcode.png'" alt="" />
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleICP() {
      window.open("https://beian.miit.gov.cn/")
    }
  }
};
</script>

<style lang="scss" scoped>
.footer {
  min-width: 1130px;
  margin-top: 20px;
  border-top: 2px solid #087cd6;
  color: #4c4c4c;
  background-color: #fff;
}

.footer-wrap {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 32px 0;
  line-height: 1.5em;
  .plate {
    width: 28%;

    .title {
      margin-bottom: 20px;
      font-size: 16px;
      color: #fff;
    }

    .content {
      p {
        display: flex;
        align-items: flex-start;
        margin-bottom: 2px;

        .label {
          flex-shrink: 0;
          padding-right: 20px;
        }

        a {
          color: #c9c9c9;
        }
      }
    }
  }

  .left {
    display: flex;
    flex-direction: column;

    .logo {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      // margin-top: -8px;

      .img-wrap {
        width: 70px;
        height: 70px;
      }

      .content {
        margin-left: 12px;
        font-size: 32px;
        color: #fff;
      }
    }
  }
  .center {
    // flex: 1;
    margin: 0 40px;

    .content {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .label {
        padding-right: 20px;
      }
      .icp-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        .label {
          padding-right: 20px;
        }
        :nth-child(2) {
          cursor: pointer;
        }
      }
    }
  }
  .right {
    position: relative;

    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;

      .r-item {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 32%;
        cursor: pointer;
        z-index: 10;

        .item-top {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 10px;
          width: 100%;
          height: 100%;
          min-height: 108px;
          background-color: #fff;

          .txt {
            font-size: 10px;
            color: #999;
          }
        }

        .item-bot {
          transform: scale(0.8);
          text-align: center;
        }

        .txt {
          margin-top: 2px;
          font-size: 8px;
          color: #fff;
        }
      }
      .img-wrap {
        max-width: 110px;
        height: 70px;
      }
      .img {
        height: 70px;
        width: 70px;
      }
      .amplify {
        display: none;
        position: absolute;
        right: -80px;
        bottom: 150px;
        width: 400px;
        height: 400px;
        background-color: #fff;
        border: 1px solid #f2f2f2;
        border-bottom: 0;
        box-shadow: 0 2px 2px rgba($color: #000000, $alpha: 0.05);

        .item-top {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 400px;
          height: 400px;
          background-color: #fff;

          .img-wrap1 {
            width: 80%;
            height: 80%;

            .img {
              width: 100%;
              height: 100%;
            }
          }

          .txt {
            margin-top: 2px;
            font-size: 24px;
            color: #333;
          }
        }

        .triangle {
          position: absolute;
          bottom: -40px;
          right: 24%;
          transform: translate(-50%, 0);
          border: 20px solid #fff;
          border-color: #fff transparent transparent transparent;
        }
      }
    }

    .r-item1:hover {
      .amplify1 {
        display: flex;
      }
    }

    .r-item2:hover {
      .amplify2 {
        display: flex;
      }
    }

    .r-item3:hover {
      .amplify3 {
        display: flex;
      }
    }
  }
}
</style>
